/* prettier-ignore */

import { inject, Injectable } from '@angular/core';
import { INFORMER_MODE_STORAGE_KEY, INFORMER_REGISTER_STORAGE_KEY, InformerMode } from '../interfaces/informer-mode.interface';
import { DebugService } from './debug.service';
import { ToolsService } from './tools.service';

/**
 * HRS-3145: único sitio por el que se **entra** al modo del informador. Antes
 * lo hacía `AppComponent.initializeParams` al leer el query param; ahora lo
 * llaman los guards de `/tech-mode/...` y de los params heredados.
 *
 * Fija las señales y persiste el modo (TTL de 2 h, como el resto de params de
 * entrada) para que `AppComponent.checkInformerMode` lo restaure al navegar.
 * Salir del modo sigue siendo cosa del botón de la cabecera (`tech-exit`).
 */
@Injectable({ providedIn: 'root' })
export class InformerModeEntryService {
  private _tools = inject(ToolsService);
  private _debug = inject(DebugService);

  enter(mode: InformerMode, registerId: string | null = null): void {
    this._debug.info(`Enabling Informer Mode: ${mode}`, '[InformerModeEntry]');
    this._tools.informerMode.set(mode);
    this._tools.setWithExpiry(INFORMER_MODE_STORAGE_KEY, mode);

    // Solo tiene sentido dentro de un modo del informador: en el planner del
    // turista el registro lo decide la app, no la URL.
    if (registerId) {
      this._tools.informerRegisterId.set(registerId);
      this._tools.setWithExpiry(INFORMER_REGISTER_STORAGE_KEY, registerId);
    }
  }
}
